import styled from 'styled-components';
import {modalAppearanceSetup} from '../modal-condition/modalAppearanceSetup';

const Backdrop = styled.button`
    background: var(--container-background-color-backdrop);
    cursor: pointer;
    pointer-events: fill;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: var(--z-index-modal-backdrop);
    top: 0;
    left: 0;
    ${({show}) => modalAppearanceSetup(show)};
`;

export default Backdrop;
